const MEDIA_PREFIX = 'PNP_MUG|';
const MEDIA_TARGETS = [
  'slideshow-slide',
  '.slideshow-controls__thumbnail',
  '.dialog-thumbnails-list__thumbnail',
  '.dialog-zoomed-gallery > li',
  '.media-gallery__grid > li',
];

function normalise(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-');
}

function parseMedia(alt) {
  if (!alt.startsWith(MEDIA_PREFIX)) return null;

  return alt
    .slice(MEDIA_PREFIX.length)
    .split('|')
    .reduce((metadata, pair) => {
      const [key, value] = pair.split('=', 2);
      if (key && value) metadata[normalise(key)] = normalise(value);
      return metadata;
    }, {});
}

function selectedOptionsFromPicker() {
  return Array.from(document.querySelectorAll('variant-picker :is(input:checked, option:checked)')).reduce(
    (options, input) => {
      const name = input.dataset.optionName || input.name?.match(/^options\[(.+)\]$/)?.[1];
      if (name) options[normalise(name)] = normalise(input.value);
      return options;
    },
    {}
  );
}

function selectedOptionsFromEvent(event) {
  if (!Array.isArray(event.selectedOptions)) return {};

  return event.selectedOptions.reduce((options, option) => {
    options[normalise(option.name)] = normalise(option.value);
    return options;
  }, {});
}

function mediaMatches(metadata, options) {
  const petCount = options['number-of-pets'] || options.pets || '1';
  const colour = options.colour || options.color || 'yellow';

  return metadata.colour === colour && (metadata.pets === petCount || metadata.pets === 'all');
}

function toggleMediaElement(image, visible) {
  for (const selector of MEDIA_TARGETS) {
    const target = image.closest(selector);
    if (!target) continue;

    target.classList.toggle('pnp-mug-media--visible', visible);
    target.toggleAttribute('hidden', !visible);
  }
}

function selectFirstVisibleSlide(gallery) {
  const slideshow = gallery.querySelector('slideshow-component');
  const slide = gallery.querySelector('slideshow-slide.pnp-mug-media--visible');
  const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
  const slideIndex = slide ? slides.indexOf(slide) : -1;

  if (!slideshow || slideIndex < 0 || typeof slideshow.select !== 'function') return;
  slideshow.select(slideIndex, undefined, { animate: false });
}

function updateGallery(options = selectedOptionsFromPicker()) {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    let taggedMediaCount = 0;

    gallery.querySelectorAll(`img[alt^="${MEDIA_PREFIX}"]`).forEach((image) => {
      const metadata = parseMedia(image.alt);
      if (!metadata) return;

      taggedMediaCount += 1;
      toggleMediaElement(image, mediaMatches(metadata, options));
    });

    if (!taggedMediaCount) return;
    gallery.classList.add('pnp-mug-gallery--ready');
    requestAnimationFrame(() => selectFirstVisibleSlide(gallery));
  });
}

let updatePending = false;

function scheduleGalleryUpdate() {
  if (updatePending) return;
  updatePending = true;

  requestAnimationFrame(() => {
    updatePending = false;
    updateGallery();
  });
}

let galleryObserver;

function observeProductMorphs() {
  if (galleryObserver) return;
  const productRoot = document.querySelector('#MainContent') || document.querySelector('main');
  if (!productRoot) return;

  galleryObserver = new MutationObserver(() => scheduleGalleryUpdate());
  galleryObserver.observe(productRoot, { childList: true, subtree: true });
}

document.addEventListener('shopify:product:select', (event) => {
  updateGallery({ ...selectedOptionsFromPicker(), ...selectedOptionsFromEvent(event) });
  scheduleGalleryUpdate();
});

document.addEventListener('DOMContentLoaded', () => {
  observeProductMorphs();
  updateGallery();
});
document.addEventListener('shopify:section:load', () => updateGallery());
document.addEventListener('change', (event) => {
  if (event.target instanceof Element && event.target.closest('variant-picker')) scheduleGalleryUpdate();
});
window.addEventListener('load', () => updateGallery());

customElements.whenDefined('slideshow-component').then(() => updateGallery());

if (document.readyState !== 'loading') {
  observeProductMorphs();
  updateGallery();
}
